module.exports = __webpack_public_path__ + "static/media/lds-logo_to.f21bd9ab.svg";